import { render, staticRenderFns } from "./AliasForm.vue?vue&type=template&id=b6a4e2c0&scoped=true"
import script from "./AliasForm.vue?vue&type=script&lang=js"
export * from "./AliasForm.vue?vue&type=script&lang=js"
import style0 from "./AliasForm.vue?vue&type=style&index=0&id=b6a4e2c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a4e2c0",
  null
  
)

export default component.exports